module.exports = __webpack_public_path__ + "img/english-premier-league-36__dark.c4850b4f.png";